export default {
    name: 'Store',
    dimensions: { width: 20, height: 21 },
    content: `
    <g fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round">
      <path d="M1 7.24998L2.77208 1.93375C2.90819 1.52541 3.29033 1.24998 3.72076 1.24998H16.2792C16.7097 1.24998 17.0918 1.52541 17.2279 1.93375L19 7.24998"/>
      <path d="M1 7.24998H19"/>
      <path d="M7 7.24998V8.24998C7 9.90998 8.34 11.25 10 11.25C11.66 11.25 13 9.90998 13 8.24998V7.24998"/>
      <path d="M13 7.24998V8.24998C13 9.90998 14.34 11.25 16 11.25C17.66 11.25 19 9.90998 19 8.24998V7.24998"/>
      <path d="M1 7.24998V8.24998C1 9.90998 2.34 11.25 4 11.25C5.66 11.25 7 9.90998 7 8.24998V7.24998"/>
      <path d="M3 19.25V11.07"/>
      <path d="M17 19.25V11.07"/>
      <path d="M1 19.25H19"/>
      <path d="M7 6.24998L8 1.24998"/>
      <path d="M13 6.24998L12 1.24998"/>
    </g>
  `
};



